module.exports = __webpack_public_path__ + "static/media/bt_top_literally_report_over.0da52604.png";